// extracted by mini-css-extract-plugin
module.exports = {"signUp":"SignUp_signUp__10HGA","type":"SignUp_type__T--eI"};